import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Globals from "../Globals.js";
import { ModalConfirm, ModalAlert } from "../su/Modals.js";
import PageObserve from "./PageObserve.js";


export default class PageCreateAccount extends PageCommon {
    constructor() {
        super();
    }
    init($data) {
        super.init($data);
        this.showPreloader(false);

        // dispaccio un evento globale
        try {
            this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
        } catch (error) {
            console.log(error);
        }

        PageCommon.disable($(".js-registrati"), true);

        $(".js-email").keyup(this.onCheckData.bind(this));
        $(".js-name").keyup(this.onCheckData.bind(this));
        $(".js-surname").keyup(this.onCheckData.bind(this));
        $(".js-type").change(this.onCheckData.bind(this));
        $(".js-privacy").change(this.onCheckData.bind(this));
        $(".js-registrati").on("click", this.onDoSubmit.bind(this));
        $("body").keydown(this.onSendData.bind(this));
    }


    onCheckData() {
        var mailformat = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;

        let Email = $.trim($(".js-email").val());
        let Name = $.trim($(".js-name").val());
        let Surname = $.trim($(".js-surname").val());
        let Privacy = $(".js-privacy").prop('checked') === true;
        let Type = $.trim($(".js-type").val());
        let City = $.trim($('.js-city').val());
        let Province = $.trim($('.js-province').val());

        if (Email !== "" && Email.match(mailformat) && Name !== "" && Surname !== "" && Type !== "" && Privacy && Province != '' && City != '') {
            PageCommon.disable($(".js-registrati"), false);
            return true;
        } else {
            PageCommon.disable($(".js-registrati"), true);
            return false;
        }
    }

    onSendData(e) {
        if (e.which == 13 && this.onCheckData()) {
            this.onDoSubmit();
        }
    }

    onDoSubmit(e) {
        this.showPreloader(true);

        let Email = $.trim($(".js-email").val());
        let FirstName = $.trim($(".js-name").val());
        let LastName = $.trim($(".js-surname").val());
        let Privacy = $(".js-privacy").prop('checked') === true;
        let Role = $.trim($(".js-type").val());
        let Province = $.trim($('.js-province').val());
        let City = $.trim($('.js-city').val());

        let rq = {
            Email,
            FirstName,
            LastName,
            Privacy,
            Province,
            City,
            Role
        }
        thatServiceManeger.standardCall("/api/app/createaccount", rq, this.onDoSubmitHandler.bind(this));
    }

    onDoSubmitHandler(rs) {
        // console.log(rs);
        this.showPreloader(false);

        let showError = false;
        if (rs.StatusCode !== 200) {
            showError = true;
        } else {
            showError = !rs.Success;
        }

        if (showError) {
            let error = null;
            if (rs.hasOwnProperty('Errors') && rs.Errors !== null && rs.Errors.length > 0) {
                error = TheApp.Res[TheApp.Locale]["ERROR." + rs.Errors[0].Code];
                if (!error) {
                    error = TheApp.Res[TheApp.Locale][rs.Errors[0].Code];
                }
                if (rs.Errors[0].RefsUid.length > 0) {
                    error = error?.replace("{0}", rs.Errors[0].RefsUid);
                }
            }
            if (!error)
                error = TheApp.Res[TheApp.Locale]["ERROR.CREATEACCOUNT.DEFAULT"];

            let modal = new ModalAlert($("#template-modalAlert"));
            modal.create(
                {
                    title: "ERRORE",
                    body: error,
                    close: "CHIUDI",
                    error: true
                });
            modal.init();
            return;
        } else {

            $(".js-thank-you-name").html(rs.myProfile.FirstName);

            // Success
            $(".js-form-register").hide();
            $(".js-thank-you").show();
        }
    }


}

